import { render } from "./Preventive.vue?vue&type=template&id=b3ef3d80&scoped=true&ts=true"
import script from "./Preventive.vue?vue&type=script&lang=ts"
export * from "./Preventive.vue?vue&type=script&lang=ts"

import "./Preventive.vue?vue&type=style&index=0&id=b3ef3d80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ef3d80"]])

export default __exports__